import { useState, useEffect, useCallback } from "react"
import { debounce } from "throttle-debounce"

export const useIsPortableDevice = () => {
  const [isIsPortableDevice, setIsPortableDevice] = useState(false)
  const tellSize = () => {
    setIsPortableDevice(window.innerWidth < 1128 ? true : false)
  }
  const debounceTellSize = useCallback(debounce(150, tellSize), [])

  useEffect(() => {
    window.addEventListener("resize", debounceTellSize)
    return () => {
      window.removeEventListener("resize", debounceTellSize)
    }
  }, [])
  useEffect(debounceTellSize, [])
  return isIsPortableDevice
}
